import { render, staticRenderFns } from "./ConfirmDeletionModal.vue?vue&type=template&id=c81ff0e2&scoped=true&"
import script from "./ConfirmDeletionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeletionModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDeletionModal.vue?vue&type=style&index=0&id=c81ff0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81ff0e2",
  null
  
)

export default component.exports